import { render, staticRenderFns } from "./lauatd.vue?vue&type=template&id=5fc36615&"
import script from "./lauatd.vue?vue&type=script&lang=js&"
export * from "./lauatd.vue?vue&type=script&lang=js&"
import style0 from "./lauatd.vue?vue&type=style&index=0&id=5fc36615&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc36615')) {
      api.createRecord('5fc36615', component.options)
    } else {
      api.reload('5fc36615', component.options)
    }
    module.hot.accept("./lauatd.vue?vue&type=template&id=5fc36615&", function () {
      api.rerender('5fc36615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/revenueSsharing/lauatd.vue"
export default component.exports